export const environment = {
  production: true
};



// WEBPACK FOOTER //
// ./apps/nox/src/environments/environment.ts